import { useState } from 'react';

import { Stack, Typography } from '@mui/material';

import { say } from '@/james-playground/aa-family-claim/claim/asks';
import { CONSENT } from '@/james-playground/aa-family-claim/claim/cards/cards.content';
import {
  CardShell,
  ChoiceCards,
} from '@/james-playground/aa-family-claim/claim/cards/parts';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';

/**
 * Q20, DWP contacting the people who know about her conditions, on a card
 * of its own with the form's explanation. No is allowed. Consent given
 * anywhere else in the app does not count here, so only the family's own
 * earlier answer to this question is carried in.
 */
const ConsentCard = ({ ask, facts, voice: v, onSubmit, onSkip }: CardProps) => {
  const id = ask.entries[0];
  const earlier = facts[id];
  const [pick, setPick] = useState(
    earlier?.state === 'confirmed' &&
      earlier.source === 'family' &&
      typeof earlier.value === 'string'
      ? earlier.value
      : '',
  );

  return (
    <CardShell
      label={say(ask.title, v)}
      ready={pick === 'Yes' || pick === 'No'}
      onSkip={onSkip}
      onContinue={() =>
        onSubmit({ [id]: pick }, pick === 'Yes' ? CONSENT.yes : CONSENT.no)
      }
    >
      <Stack spacing={1}>
        {CONSENT.body.map((line) => (
          <Typography key={line} variant='body2'>
            {say(line, v)}
          </Typography>
        ))}
      </Stack>
      <ChoiceCards
        label={say(ask.title, v)}
        options={[
          { value: 'Yes', label: CONSENT.yes },
          {
            value: 'No',
            label: CONSENT.no,
            detail: <Typography variant='body2'>{CONSENT.noNote}</Typography>,
          },
        ]}
        selected={pick ? [pick] : []}
        onPick={setPick}
      />
      <Typography variant='caption'>{CONSENT.signs}</Typography>
    </CardShell>
  );
};

ConsentCard.displayName = 'ConsentCard';
export default ConsentCard;
